/**
 * Conversion reporting. Only ever called after a Media Matchers Post has
 * confirmed — never on button click, so a failed post is not counted as a lead.
 */
export function trackLeadConversion(detail: {
  source: 'tcpa' | 'leads'
  brand?: string
}): void {
  const w = window as unknown as {
    fbq?: (...args: unknown[]) => void
  }
  if (typeof w.fbq === 'function') {
    w.fbq('track', 'Lead', {
      content_name: detail.brand || detail.source,
    })
  }
  console.log('[Conversion] Lead reported', detail)
}
